import {
    Component,
    OnInit,
    Input,
    OnDestroy,
    ViewChild,
    ElementRef
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { map, takeWhile, tap, share, filter } from 'rxjs/operators';
import { Observable, ReplaySubject, combineLatest, fromEvent } from 'rxjs';
import { CalcType } from '../../lookups';

import * as fromStore from '../store';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
@Component({
    selector: 'ef-indirect-rate-container',
    templateUrl: './indirect-rate-container.component.html',
    styleUrls: ['./indirect-rate-container.component.scss'],
    standalone: false
})
export class IndirectRateContainerComponent implements OnInit, OnDestroy {
    process$: Observable<fromShared.Process>;
    selectedError$: Observable<fromShared.Errors.IShowErrors>;
    selectedErrorWithStatus$: Observable<fromShared.IStatusMessage>;
    ShowErrorSubject = new ReplaySubject<fromShared.Errors.IShowErrors>(1);
    private active = true;
    constructor(
        private log: LoggingService,
        private store: Store<fromStore.Structure.State>
    ) {}

    ngOnInit() {
        this.store.dispatch(fromStore.Structure.getIndirectRateStructures({}));
        this.store.dispatch(fromStore.Structure.getIndirectRateTypes());
    }
    setupObservables() {
        this.setupObservables();

        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        combineLatest([this.process$, this.ShowErrorSubject])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });
        this.selectedError$ = this.store.pipe(
            select(fromShared.Errors.getShowErrors),
            tap(selected =>
                this.log.verbose({
                    type: 'IndirectRateContainerComponent:selectedError$',
                    selected
                })
            )
        );
        const errors$ = this.store.pipe(select(fromShared.Errors.getErrors));
        this.selectedErrorWithStatus$ = combineLatest([
            this.selectedError$,
            errors$
        ]).pipe(
            tap(([selected, errors]) =>
                this.log.verbose({
                    type: 'IndirectRateContainerComponent:errors$',
                    errors,
                    selected
                })
            ),
            map(
                ([selected, errors]) =>
                    errors.filter(
                        e =>
                            e.MsgEntityID === selected.MsgEntityID &&
                            e.MsgProcessID === selected.MsgProcessID
                    )[0]
            ),
            tap(selected =>
                this.log.verbose({
                    type: 'IndirectRateContainerComponent:errors$:filtered',
                    selected
                })
            )
        );
    }
    ngOnDestroy() {
        this.active = false;
    }
    onShowError(event) {
        this.ShowErrorSubject.next(event);
    }
}
